<template>
  <div class="map-box">
    <div class="map-bg"></div>
    <div class="total-num">
      <div class="num">
        今日质控报告数：<span>{{ totalNum }}</span>
      </div>
      <span class="sametime-num">同期环比：</span>
      <span
        :style="{ color: getTodayReportNum.randomColor }"
        class="today-report-num"
      >
        <el-icon v-if="getTodayReportNum.randomColor === 'green'"
          ><Top
        /></el-icon>
        <el-icon v-if="getTodayReportNum.randomColor === 'red'"
          ><Bottom
        /></el-icon>
        {{ getTodayReportNum.randomNum }}
      </span>
    </div>
    <div id="map"></div>
    <div class="option-choose">
      <div class="hospital-select">
        <span>选择医院</span>
        <el-select v-model="hospital" placeholder="请选择医院">
          <el-option label="医院1" value="1" />
          <el-option label="医院2" value="2" />
          <el-option label="医院3" value="3" />
        </el-select>
      </div>
      <div class="time-select">
        <span>选择时间</span>
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from "vue";
import dayjs from "dayjs";
import { Top, Bottom } from "@element-plus/icons-vue";
import * as echarts from "echarts";
const totalNum = ref(98658);
const hospital = ref("1");
const time = ref(["2024-01-01", "2024-12-31"]);
onMounted(() => {
  setDefaultTime();
  getChinaMap();
});
const getChinaMap = () => {
  // src/assets/china.json
  fetch("./china.json")
    .then((response) => response.json())
    .then((geoJSON) => {
      echarts.registerMap("China", geoJSON); // 注册为 'China'
      initMap();
    });
};
const setDefaultTime = () => {
  time.value = [
    dayjs().subtract(1, "year").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ];
};
const initMap = () => {
  // 使用echarts画地图
  const myChart = echarts.init(document.getElementById("map"));
  const option = {
    backgroundColor: "transparent",
    title: {
      text: "中国地图示例",
      left: "center",
      show: false,
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}<br/>值: {c}", // 显示地区名称和数值
      show: false,
    },
    visualMap: {
      // 颜色映射组件
      left: "right",
      min: 0,
      max: 1000,
      text: ["高", "低"],
      calculable: true,
      inRange: {
        color: ["#e0ffff", "#006edd"], // 颜色区间
      },
      textStyle: {
        color: "#fff",
      },
    },
    geo: {
      // 地理坐标系配置
      map: "China", // 对应注册的名称
      zoom: 1.2,
      center: [104.0, 35.0], // 经度、纬度
      roam: false, // 允许缩放和拖动
    },
    series: [
      // 数据系列（可选）
      {
        type: "map",
        map: "China",
        selectedMode: "multiple",
        // 默认选中的城市
        data: [
          { name: "湖北省", selected: true }, // 通过selected:true高亮指定省份
          { name: "湖南省", selected: true },
        ],
        roam: false,
        zoom: 1.2,
        center: [104.0, 35.0], // 经度、纬度
        itemStyle: {
          // 地图区域样式
          areaColor: "#1b2a4c", // 默认颜色
          borderColor: "#2a3f66", // 边框颜色
        },
        emphasis: {
          show: true,
          // 高亮状态
          itemStyle: {
            areaColor: "#2a3f66", // 鼠标悬停颜色
          },
          label: {
            show: false,
          },
        },
        select: {
          itemStyle: {
            areaColor: "#2a3f66", // 选中状态的颜色
            borderColor: "#0e1a33", // 边框颜色
          },
          label: {
            show: false,
          },
        },
        tooltip: {
          show: false,
        },
      },
      {
        type: "effectScatter",
        coordinateSystem: "geo",
        roam: false,
        data: [
          { name: "广州", value: [113.28, 23.12, 1000] },
          { name: "北京", value: [116.46, 39.92, 800] },
          { name: "乌鲁木齐", value: [87.62, 43.79, 300] },
          { name: "上海", value: [121.48, 31.22, 600] },
          { name: "深圳", value: [114.07, 22.62, 500] },
          { name: "成都", value: [104.07, 30.67, 400] },
          { name: "重庆", value: [106.54, 29.59, 300] },
          { name: "西安", value: [108.95, 34.28, 200] },
          { name: "武汉", value: [114.31, 30.57, 100] },
          { name: "长沙", value: [112.98, 28.19, 50] },
          { name: "兰州", value: [103.73, 36.03, 100] },
          { name: "西宁", value: [101.74, 36.62, 100] },
          { name: "银川", value: [106.27, 38.47, 100] },
          { name: "乌鲁木齐", value: [87.62, 43.79, 300] },
          { name: "克拉玛依", value: [84.88, 45.59, 100] },
          { name: "吐鲁番", value: [89.18, 42.94, 100] },
          { name: "哈密", value: [93.51, 42.83, 100] },
        ],
        symbolSize: function (val) {
          // val[2] 是你的数值，根据数值动态调整圆点大小
          return Math.max(2, val[2] / 80); // 你可以根据实际需求调整
        },
        showEffectOn: "render",
        rippleEffect: {
          brushType: "stroke",
        },
        itemStyle: {
          color: "#3fa7ff", // 圆点颜色
          shadowBlur: 10,
          shadowColor: "#333",
        },
        label: {
          show: false,
          position: "top",
          color: "#fff",
          fontSize: 12,
          formatter: (params) => {
            return `${params.name} ${params.value[2]}`;
          },
        },
        emphasis: {
          scale: false,
        },
        tooltip: {
          show: true,
          formatter: (params) => {
            return `${params.name}<br/>${params.value[2]}`;
          },
        },
      },
    ],
  };

  myChart.setOption(option);
};
const getTodayReportNum = computed(() => {
  // 随机显示增长或者减少，增加或者减少的数值为100-1000之间的随机数，增加为向上箭头icon，减少为向下箭头icon <el-icon><Top /></el-icon>
  const randomNum = Math.floor(Math.random() * 900) + 100;
  const randomColor = Math.random() > 0.5 ? "green" : "red";
  return {
    randomNum,
    randomColor,
  };
});
// 每分钟更新一次totalNum
const updateTotalNum = () => {
  totalNum.value = totalNum.value + Math.floor(Math.random() * 900) + 100;
};
setInterval(updateTotalNum, 60000);
</script>
<style scoped lang="less">
@import "@/assets/css/global.less";
.map-box {
  width: 100%;
  height: 100%;
  margin: 16px;
  color: #7ec7fd;
  font-size: 20px;
  position: relative;
  .map-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #010715 url("../assets/bg.jpeg") no-repeat center top;
    background-size: auto 100%;
    opacity: 0.1;
  }
  .total-num {
    position: absolute;
    z-index: 100;
    top: 50px;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 24px;
    .num {
      margin-bottom: 10px;
      display: inline-block;
    }
    span {
      color: #fff;
    }
  }
  .option-choose {
    width: 600px;
    position: absolute;
    z-index: 100;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .hospital-select {
      flex: 1;
      display: flex;
      align-items: center;
      span {
        flex: 0 0 80px;
        margin-right: 10px;
        font-size: 16px;
      }
    }
    .time-select {
      flex: 0 0 400px;
      display: flex;
      align-items: center;
      span {
        flex: 0 0 90px;
        margin-right: 10px;
        font-size: 16px;
      }
    }
  }
  #map {
    width: 99%;
    height: 99%;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
}
.sametime-num {
  padding-left: 20px;
  padding-right: -5px;
  color: #7ec7fd !important;
}
.today-report-num {
  font-size: 20px;
  .el-icon {
    position: relative;
    top: 3px;
  }
}
</style>
